'use client'
import React, { useState, useEffect, useRef } from 'react'

import CategoryProjectFilter from '@components/Search/CategoryProjectFilter'
// import MultiDistrictFilter from '@components/Search/MultiDistrictFilter'
// import NameFilter from '@components/Search/NameFilter'

import { saleTypes, categoryTypes, roomTypes, roomHouseTypes, condoRoomTypes, houseRoomTypes } from '@constants'
import { AiOutlineMenuFold } from 'react-icons/ai'
import { FaMapMarkerAlt, FaList } from 'react-icons/fa'
import tailwindConfig from '@tailwind.config'
import { updateSearchParams, removeParams, removeSearchParam } from "@utils";
import { useRouter } from 'next/navigation'




const FilterProjectTab = ({ searchParams, districtList, lang, dictionary }) => {
    const router = useRouter();

    const filterRef = useRef(null);


    // const [isFilterOpen, setIsFilterOpen] = useState(router?.query?.filter || false);
    const [isFilterOpen, setIsFilterOpen] = useState(true);
    const [filterOn, setFilterOn] = useState(false);
    const [search, setSearch] = useState(searchParams)
    // const [salePriceFilter, setSalePriceFilter] = useState(searchParams.saleType || saleTypes[lang][0].value)
    const [categoryFilter, setCategoryFilter] = useState(searchParams.category)
    // const [sort, sortFilter] = useState(searchParams.sort || 'datedesc')
    // const [showMap, setShowMap] = useState(searchParams.map || false);

    useEffect(() => {
        function openFilterTab() {
            setIsFilterOpen(true)
        }

        let openFilter = searchParams.filtertab

        if (openFilter == 'true') {
            openFilterTab()
        }
    }, [])

    const handleMapChange = (e) => {
        setShowMap(e);
        let newPathName
        if (e == true) {
            newPathName = updateSearchParams('map', true);
        } else {
            newPathName = removeSearchParam('map');
        }

        router.push(newPathName);
        router.refresh()
    };

    useEffect(() => {
        if (!filterRef?.current) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    filterRef.current.style.position = 'sticky';
                    filterRef.current.style.top = '0';
                }/* else {
                    filterRef.current?.style.position = 'absolute';
                    filterRef.current?.style.top = '20px'; // Adjust as needed
                }*/
            },
            {
                root: null,
                threshold: 0,
            }
        );

        observer.observe(filterRef.current);

        // return () => {
        //     observer.unobserve(filterRef.current);
        // };
    }, []);

    useEffect(() => {
        // const searchPar = new URLSearchParams(window.location.search);
        if (search != searchParams) {
            setSearch(searchParams)
            // if (searchParams.saleType === 'rent') {
            //     setSalePriceFilter('rent')
            //     // updateSearchParams('minprice', '0');
            //     // updateSearchParams('maxprice', '10000000');
            // } else {
            //     setSalePriceFilter(saleTypes[lang][0].value)
            //     // updateSearchParams('minprice', '0');
            //     // updateSearchParams('maxprice', '10000000');
            // }

            if (searchParams.category === 'condo') {
                setCategoryFilter('condo')
                // updateSearchParams('minprice', '0');
                // updateSearchParams('maxprice', '10000000');
            } else if (searchParams.category === 'house') {
                setCategoryFilter('house')
                // updateSearchParams('minprice', '0');
                // updateSearchParams('maxprice', '10000000');
            } else if (searchParams.category == undefined) {
                setCategoryFilter(undefined)
            } else {
                setCategoryFilter('')
            }

            if (searchParams.category !== undefined || searchParams.room !== undefined || searchParams.minprice !== undefined || searchParams.maxprice !== undefined) {
                setFilterOn(true)
            } else {
                setFilterOn(false)
            }
        }
    }, [searchParams])

    return (

            <div className='w-full mb-4 z-[80]' ref={filterRef}>
                {!isFilterOpen && (
                <div className='sm:w-full 2xl:w-10/12 max-w-[1600px] bg-light flex flex-col justify-between items-center px-3 pt-2  mx-auto'>
                    <div className='w-full flex flex-row items-center justify-between'>
                        <div className='w-1/3 px-2'>
                            <CategoryProjectFilter title="category" dictionary={dictionary} lang={lang} />
                        </div>
                    </div>
                    <div className='w-full flex flex-row items-center justify-center mt-8'>
                        <div onClick={() => (setIsFilterOpen(true))} className='absolute bg-light b-[-30px] w-[200px] flex flex-row items-center justify-center border-[1px] rounded-md shadow-md border-forth hover:border-maincolor hover:bg-maincolor text-maincolor hover:text-white p-1 cursor-pointer' title='Toggle Filter'>
                            {filterOn && (
                                <div className='absolute h-2 w-2 rounded-full bg-third top-1 right-1 z-30'></div>
                            )}
                            <span className=' mr-1 select-none'>{dictionary.more}</span>
                        </div>

                    </div>
                </div>
                )}
                {isFilterOpen ? (
                    <div className='relative top-0 left-0 right-0 z-[99] '>
                        <div className='sm:w-full 2xl:w-10/12 max-w-[1600px] mx-auto bg-light px-3 pt-2 rounded-b-md'>
                        <div className='w-full flex flex-row items-center justify-between'>
                            <div className='w-1/2 px-2'>
                                <CategoryProjectFilter title="category" dictionary={dictionary} lang={lang} />
                            </div>
                        </div>

                            {/* <div className='w-full mt-8 relative flex flex-row items-center'>
                                <div className='absolute left-0 right-0 bottom-[-15px] flex justify-center'>
                                    <div onClick={() => (setIsFilterOpen(false))} className='relative w-[200px] flex flex-row items-center justify-center border-[1px] rounded-md bg-light border-third hover:border-maincolor hover:bg-maincolor text-maincolor hover:text-white p-1 cursor-pointer'>
                                        {filterOn && (
                                            <div className='absolute h-2 w-2 rounded-full bg-third top-1 right-1 z-30'></div>
                                        )}
                                        <span className='mr-1 select-none'>{dictionary.close}</span>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                ) : null
                }
            </div >
        
    )
}

export default FilterProjectTab